import { useStaticQuery, graphql } from 'gatsby';
import { Query } from '../../__generated__/gatsby-types';

export type NextBestOfferByAccountType = 'residential' | 'commercial';

export const nextBestOfferDetailsQuery = graphql`
  {
    SmartCardSectionResidential: allContentfulSmartCardSection(
      filter: { contentful_id: { eq: "5wbWZdtGZddzGdudua6hUo" } }
    ) {
      nodes {
        ...SmartCardSectionFields
      }
    }
    SmartCardSectionCommercial: allContentfulSmartCardSection(
      filter: { contentful_id: { eq: "2iSM5rbCEHWfWBu6ax7FS2" } }
    ) {
      nodes {
        ...SmartCardSectionFields
      }
    }
  }

  fragment SmartCardSectionFields on ContentfulSmartCardSection {
    node_locale
    contentful_id
    cardGroupingDisplayType
    cardGrouping {
      ... on ContentfulSmartCard {
        ...SmartCardFields
      }
    }
  }

  fragment SmartCardFields on ContentfulSmartCard {
    header
    subHeader
    image {
      file {
        url
      }
    }
    mobileImage {
      file {
        url
      }
    }
    copy {
      raw
    }
    button {
      __typename
      buttonLink {
        ... on ContentfulApplicationPage {
          slug: url
        }
        ... on ContentfulPageArticle {
          slug
        }
        ... on ContentfulWrapperVanityUrl {
          slug: vanityUrl
        }
        ... on ContentfulWrapperMediaAsset {
          media {
            file {
              url
            }
          }
        }
        ... on ContentfulWrapperExternalLink {
          websiteUrl
        }
        ... on ContentfulPagePromotional {
          slug
        }
        ... on ContentfulPageOverlay {
          slug
        }
        ... on ContentfulPageNewsRelease {
          slug
        }
        ... on ContentfulPageList {
          slug
        }
        ... on ContentfulPageHome {
          slug
        }
        ... on ContentfulPageBasic {
          slug
        }
      }
      button {
        buttonText
      }
    }
    backgroundColor
  }
`;

export default (accountType: NextBestOfferByAccountType) => {
  const data = useStaticQuery<{
    SmartCardSectionResidential: Query['allContentfulSmartCardSection'];
    SmartCardSectionCommercial: Query['allContentfulSmartCardSection'];
  }>(nextBestOfferDetailsQuery);

  return {
    allContentfulSmartCardSection:
      accountType === 'residential'
        ? data.SmartCardSectionResidential
        : data.SmartCardSectionCommercial,
  };
};
